import { LangText } from '@/components'
import OutLink from '@/components/OutLink'
import { preFixImgUrl } from '@/utils'
import { SAGAWA_DELIVERY_BOOKING_URL } from '../constants'

const HeroBanner = () => (
  <section
    className="h-[320px] w-full bg-cover bg-center bg-no-repeat"
    style={{
      backgroundImage: `url(${preFixImgUrl('944ca51907255deac76e9f2a129df253.png')})`,
    }}
  >
    <div className="mx-auto flex h-full w-[1200px] flex-col justify-center text-white">
      <LangText
        lngKey="sagawa.hero.title"
        className="font-smiley-sans text-[40px] font-bold leading-[48px]"
      />
      <LangText
        lngKey="sagawa.hero.description"
        className="mt-[16px] text-[20px] leading-[28px] text-white"
      />
      <OutLink qrUrl={SAGAWA_DELIVERY_BOOKING_URL}>
        <button
          type="button"
          className="mt-[16px] flex h-[40px] w-fit cursor-pointer items-center justify-center rounded-full border border-[#328BF8] bg-white px-[24px] text-[16px] text-primary transition-opacity hover:opacity-90"
        >
          <LangText lngKey="sagawa.hero.bookDelivery" />
        </button>
      </OutLink>
    </div>
  </section>
)

export default HeroBanner
